const virtualProductSku = '4100010';

export default virtualProductSku;
